import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=24f41694&scoped=true&"
import script from "./DetailsPanel.vue?vue&type=script&lang=js&"
export * from "./DetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=24f41694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f41694",
  null
  
)

export default component.exports